import _ from 'lodash';

/**
 * Filter persons by name.
 * @param {Array.<Person>} inputPersons Input person array.
 * @param {String} searchText The text to be matched.
 * @returns {Array.<Person>} The filtered person array.
 */
function personSearchFilter(inputPersons, searchText) {
  if (!_.isString(searchText)) {
    return inputPersons;
  }

  const searchTexts = searchText.toLowerCase().split(' ');

  return inputPersons.filter(person => {
    const inputText = person.first_name + ' ' + person.last_name;
    for (const searchText of searchTexts) {
      if (inputText.toLowerCase().indexOf(searchText) === -1) {
        return false;
      }
    }
    return true;
  });
}

/**
 * Filter persons by languages.
 * @param {Array.<Person>} inputPersons Input person array.
 * @param {String} code The language code to be matched.
 * @returns {Array.<Person>} The filtered person array.
 */
function languageFilter(inputPersons, code) {
  if (!_.isString(code)) {
    return inputPersons;
  }

  return inputPersons.filter(person => {
    return person.spoken_languages.includes(code);
  });
}

/**
 * Filter persons by locations.
 * @param {Array.<Person>} inputPersons Input person array.
 * @param {Array.<Number>} locationIds The location ids to be matched.
 * @returns {Array.<Person>} The filtered person array.
 */
function locationFilter(inputPersons, locationIds) {
  if (locationIds == null || locationIds.length === 0) {
    return inputPersons;
  }
  return inputPersons.filter(person => {
    return person.locations.some(locId => locationIds.includes(locId));
  });
}

/**
 * Filter persons by person services
 * @param {Array.<Person>} inputPersons to filter
 * @param {Number} id of the service to be matched
 * @returns {Array.<Person>} Filtered persons
 */
function serviceFilter(inputPersons, id) {
  if (!id) {
    return inputPersons;
  }

  return inputPersons.filter(person => person.services.includes(id));
}

/**
 * Filter persons by person services that are not available from internet
 * @param {Array.<Person>} inputPersons to filter
 * @param {Number} id of the service to be matched
 * @returns {Array.<Person>} Filtered persons
 */
function nonInternetServiceFilter(inputPersons, id) {
  if (!id) {
    return inputPersons;
  }

  return inputPersons.filter(person => person.other_services.includes(id));
}


/**
 * Filter persons by service category.
 * @param {Array.<Person>} inputPersons Input person array.
 * @param {String} id The service category id to be matched.
 * @returns {Array.<Person>} The filtered person array.
 */
function serviceCategoryFilter(inputPersons, id) {
  if (!id) {
    return inputPersons;
  }

  return inputPersons.filter(person => {
    return person.service_categories.includes(id);
  });
}

/**
 * Filter persons by service group.
 * @param {Array.<Person>} inputPersons Input person array.
 * @param {String} id The service group id to be matched.
 * @returns {Array.<Person>} The filtered person array.
 */
function serviceGroupFilter(inputPersons, id) {
  if (!id) {
    return inputPersons;
  }

  return inputPersons.filter(person => {
    return person.service_groups.includes(id);
  });
}

/**
 * Filter persons by job title
 * @param {Array.<Person>} inputPersons Input person array.
 * @param {String} jobTitle The job title to be matched.
 * @returns {Array.<Person>} The filtered person array.
 */
function jobTitleFilter(inputPersons, jobTitle) {
  if (!jobTitle) {
    return inputPersons;
  }

  return inputPersons.filter(person => person.job_title === jobTitle);
}

export {personSearchFilter, languageFilter, locationFilter, serviceFilter, nonInternetServiceFilter,
  serviceCategoryFilter, serviceGroupFilter, jobTitleFilter};



// WEBPACK FOOTER //
// ./src/app/persons/person-filters.js